<template>
  <validation-observer v-if="dialogComputed" ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="dialogComputed" max-width="450px" :persistent="!isInquiry" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ setting.title }}
          <v-spacer />
          <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <v-container fluid class="px-0">
            <v-row>
              <v-col>
                <SelectSingleInput
                  v-if="isInquiry || isEdit"
                  v-model="companyCatCdComputed"
                  :label="$t('ELE0006')"
                  :items="companyCatCdItems"
                  itemText="name"
                  itemValue="value"
                  disabled
                />
                <SelectSingleInput
                  v-else
                  v-model="companyCatCdComputed"
                  :label="$t('ELE0006')"
                  :items="companyCatCdItems"
                  itemText="name"
                  itemValue="value"
                  @change="onChangeCompanyCatCd"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef v-if="isInquiry || isEdit" :label="$t('ELE0003')" :value="compCdComputed" />
                <TextFieldInput
                  v-else
                  :label="$t('ELE0003')"
                  v-model="compCdComputed"
                  :maxLength="30"
                  validationMode="lazy"
                  :debounce="500"
                  rules="halfWidth|companyCatValidation|companyLocationValidation"
                  required
                />
              </v-col>
            </v-row>
            <v-row v-if="locationRequired">
              <v-col>
                <TextFieldRef v-if="isInquiry || isEdit" :label="$t('ELE0380')" :value="locationComputed" />
                <TextFieldInput
                  v-else
                  :label="$t('ELE0380')"
                  v-model="locationComputed"
                  :maxLength="1"
                  validationMode="lazy"
                  rules="companyLocationValidation"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef :label="$t('ELE0060')" :value="gnsCompanyComputed.companyName1" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef :label="$t('ELE0061')" :value="gnsCompanyComputed.companyName2" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef v-if="isInquiry" :label="$t('ELE0004')" :value="companyNameComputed" />
                <TextFieldInput v-else :label="$t('ELE0004')" v-model="companyNameComputed" :maxLength="80" required />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <SelectSingleInput
                  v-if="isInquiry"
                  v-model="inspCatComputed"
                  :label="$t('ELE0007')"
                  :items="inspCatItems"
                  itemText="name"
                  itemValue="value"
                  disabled
                />
                <SelectSingleInput
                  v-else
                  v-model="inspCatComputed"
                  :label="$t('ELE0007')"
                  :items="inspCatItems"
                  itemText="name"
                  itemValue="value"
                  required
                  @change="onChangeInspCat"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef v-if="companyCatCd == enumCompanyCatCd.EPSON" :label="$t('ELE0005')" value="All" />
                <CompanyMultipleInput
                  v-else-if="isInquiry || inspCatComputed == enumInspCat.OQC"
                  v-model="supplierCdsComputed"
                  :label="$t('ELE0005')"
                  :companyCat="enumCompanyCatCd.SUPPLIER"
                  validOnly
                  disabled
                />
                <CompanyMultipleInput
                  v-else
                  v-model="supplierCdsComputed"
                  :label="$t('ELE0005')"
                  :companyCat="enumCompanyCatCd.SUPPLIER"
                  validOnly
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Checkbox
                  v-if="isInquiry || companyCatCd == enumCompanyCatCd.EPSON"
                  :label="$t('ELE0493')"
                  v-model="needSourceComputed"
                  :items="isSrcInsp"
                  itemText="name"
                  itemValue="value"
                  disabled
                  class="checkbox-inactive"
                />
                <Checkbox
                  v-else
                  :label="$t('ELE0493')"
                  v-model="needSourceComputed"
                  :items="isSrcInsp"
                  itemText="name"
                  itemValue="value"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Btn
                  :label="setting.editCapaButtonLabel"
                  @click="onClickEditCapacity"
                  :disabled="inspCatComputed != enumInspCat.OQC_IQC || companyCatCdComputed == '' || !capacityRequired"
                />
              </v-col>
            </v-row>
            <v-row v-if="isInquiry || isEdit">
              <v-col>
                <BtnChooseValid v-model="isValidComputed" :disabled="isInquiry" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <span class="d-flex flex-row space-between">
            <BtnClose v-if="isInquiry" @click="close" />
            <BtnSave v-else @click="onClickSave" :disabled="canSave ? invalid : true" />
          </span>
        </v-card-actions>
      </v-card>

      <EditCapacityDialog
        v-if="editCapaDialog"
        :editCapaDialog.sync="editCapaDialog"
        :editShiftLists.sync="editShiftLists"
        :editCapaInsp.sync="editCapaInsp"
        :isInquiry="isInquiry"
        @set="setCompanyCapaItems"
      />
    </v-dialog>
  </validation-observer>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import { extend, ValidationObserver } from 'vee-validate'
import Btn from '@/components/atoms/base/button/Btn'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnClose from '@/components/atoms/button/BtnClose'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnChooseValid from '@/components/atoms/button/BtnChooseValid'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import CompanyMultipleInput from '@/components/atoms/select/CompanyMultipleInput'
import EditCapacityDialog from '@/components/organisms/master/dialog/EditCapacityDialog'
import { ModalMode, CompanyCatCd, InspCat, CalendarGroup, ShiftGroup } from '@/enum'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'CompanyDialog',

  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    Btn,
    BtnSave,
    BtnClose,
    Checkbox,
    TextFieldInput,
    TextFieldRef,
    BtnChooseValid,
    SelectSingleInput,
    CompanyMultipleInput,
    EditCapacityDialog,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    // モーダルの処理モード
    mode: {
      type: String,
      required: true,
    },
    companyCd: {
      type: String,
      required: true,
    },
    compCd: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      required: false,
    },
    capacityRequired: {
      type: Boolean,
      required: true,
    },
    locationRequired: {
      type: Boolean,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
    companyCatCd: {
      type: String,
      required: false,
      default: '',
    },
    inspCat: {
      type: String,
      required: true,
      default: '',
    },
    isValid: {
      type: Boolean,
      required: true,
    },
    versionNo: {
      type: Number,
      required: true,
    },
    supplierCds: {
      type: Array,
      required: true,
      default: () => [],
    },
    capaInsp: {
      type: [String, Number],
      required: true,
    },
    gnsCompany: {
      type: Object,
      required: false,
      default: () => {},
    },
    propsShiftGroupCd: {
      type: String,
      required: false,
    },
    isSrcInsp: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      editCapaDialog: false,
      shiftLists: [],
      editShiftLists: [],
      editCapaInsp: 0,
      isOpenedEditCapaDialog: false,
      isEditedCapacity: false,
      settings: [
        {
          mode: ModalMode.ADD, // モーダルの処理モード
          title: this.$t('ELE0016'), // モーダルタイトル
          url: '/master/companies/register', // Backendのurl
          editCapaButtonLabel: this.$t('ELE0106'),
        },
        {
          mode: ModalMode.EDIT,
          title: this.$t('ELE0017'),
          url: '/master/companies/{id}/update',
          editCapaButtonLabel: this.$t('ELE0106'),
        },
        {
          mode: ModalMode.INQUIRY,
          title: this.$t('ELE0018'),
          url: '',
          editCapaButtonLabel: this.$t('ELE0327'),
        },
      ],
    }
  },

  computed: {
    enumInspCat: () => InspCat,
    enumCompanyCatCd: () => CompanyCatCd,
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    compCdComputed: {
      get() {
        return this.compCd
      },
      set(value) {
        if (value) {
          value = value.trim()
        }
        this.companyCdComputed = this.locationRequired ? value + '-' + this.location : value
        this.$emit('update:compCd', value)
      },
    },
    locationComputed: {
      get() {
        return this.location
      },
      set(value) {
        this.companyCdComputed = this.compCd + '-' + value
        this.$emit('update:location', value)
      },
    },
    companyCdComputed: {
      get() {
        return this.companyCd
      },
      set(value) {
        this.$emit('update:companyCd', value)
      },
    },
    companyNameComputed: {
      get() {
        return this.companyName
      },
      set(value) {
        this.$emit('update:companyName', value)
      },
    },
    companyCatCdComputed: {
      get() {
        return this.companyCatCd
      },
      set(value) {
        this.$emit('update:companyCatCd', value)
      },
    },
    inspCatComputed: {
      get() {
        return this.inspCat
      },
      set(value) {
        this.$emit('update:inspCat', value)
      },
    },
    isValidComputed: {
      get() {
        return this.isValid
      },
      set(value) {
        this.$emit('update:isValid', value)
      },
    },
    needSourceComputed: {
      get() {
        return this.isSrcInsp
      },
      set(value) {
        this.$emit('update:isSrcInsp', value)
      },
    },
    versionNoComputed: {
      get() {
        return this.versionNo
      },
    },
    supplierCdsComputed: {
      get() {
        return this.supplierCds
      },
      set(value) {
        this.$emit('update:supplierCds', value)
      },
    },
    capaInspComputed: {
      get() {
        return this.capaInsp
      },
      set(value) {
        this.$emit('update:capaInsp', value)
      },
    },
    gnsCompanyComputed: {
      get() {
        return this.gnsCompany
      },
      set(value) {
        this.$emit('update:gnsCompany', value)
      },
    },
    setting: {
      get() {
        // モーダルの処理モードに該当する設定取得
        return this.settings.find((el) => el.mode === this.mode)
      },
    },
    isAdd: {
      get() {
        // 追加モードでopenしているか判定
        return this.setting.mode === ModalMode.ADD
      },
    },
    isEdit: {
      get() {
        // 編集モードでopenしているか判定
        return this.setting.mode === ModalMode.EDIT
      },
    },
    isInquiry: {
      get() {
        // 参照モードでopenしているか判定
        return this.setting.mode === ModalMode.INQUIRY
      },
    },
    companyCatCdItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(CompanyCatCd).map((item) => {
          return { name: item + ' : ' + this.$t(`company.companyCatcd.${item}`), value: item }
        })
      },
    },
    inspCatItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(InspCat).map((item) => {
          return { name: item + ' : ' + this.$t(`company.inspCat.${item}`), value: item }
        })
      },
    },
    calendarGroupCd: {
      get() {
        let result = ''
        if (this.companyCatCdComputed == CompanyCatCd.EPSON) {
          result = CalendarGroup.EPSON
        } else if (this.companyCatCdComputed == CompanyCatCd.SUPPLIER) {
          result = CalendarGroup.SUPPLIER
        }
        return result
      },
    },
    shiftGroupCd: {
      get() {
        let result = ''
        if (this.companyCatCdComputed == CompanyCatCd.EPSON) {
          result = ShiftGroup.EPSON
        } else if (this.companyCatCdComputed == CompanyCatCd.SUPPLIER) {
          result = ShiftGroup.SUPPLIER
        }
        return result
      },
    },
    canSave: {
      get() {
        let result = false
        if (this.inspCatComputed == InspCat.OQC) {
          result = true
        } else {
          if (this.isEditedCapacity) {
            result = true
          }
        }
        return result
      },
    },
  },

  watch: {
    dialog() {
      if (this.isEdit) {
        this.isEditedCapacity = true
      }
    },
  },

  methods: {
    close() {
      // モーダルclose
      this.supplierCdsComputed = []
      this.dialogComputed = false
      this.isOpenedEditCapaDialog = false
    },
    async onChangeInspCat() {
      await setImmediate(() => {})
      this.clearAcceptCompany()
      // 編集モード時、ShiftListsの処理
      if (this.isEdit) {
        this.shiftLists = []
        this.isEditedCapacity = false
        this.isOpenedEditCapaDialog = false
      }
      this.capaInspComputed = ''
      if (!this.capacityRequired && this.inspCat == InspCat.OQC_IQC) {
        await this.autoFillCapacity()
      }
    },
    onChangeCompanyCatCd() {
      this.resetField()
    },
    clearAcceptCompany() {
      if (this.inspCatComputed == InspCat.OQC) {
        this.supplierCdsComputed = []
      }
    },
    async onClickEditCapacity() {
      if (!this.isOpenedEditCapaDialog) {
        if (this.isAdd) {
          this.shiftLists = await this.getEmptyShiftLists()
        } else {
          this.shiftLists = await this.getShiftLists()
        }
        this.isOpenedEditCapaDialog = true
      }
      this.editShiftLists = cloneDeep(this.shiftLists)
      this.editCapaInsp = cloneDeep(this.capaInspComputed)
      this.editCapaDialog = true
    },
    async autoFillCapacity() {
      if (this.isAdd) {
        let tempShiftList = await this.getEmptyShiftLists()
        this.shiftLists = tempShiftList.map((element) => {
          Object.keys(element).forEach((key) => {
            if (key != 'shiftCd' && key != 'shiftName') {
              element[key] = 0
            }
          })
          return element
        })
      } else {
        this.shiftLists = await this.getShiftLists()
      }
      this.isEditedCapacity = true
    },
    setCompanyCapaItems() {
      this.shiftLists = cloneDeep(this.editShiftLists)
      this.capaInspComputed = cloneDeep(this.editCapaInsp)
      this.isEditedCapacity = true
    },
    async onClickSave() {
      try {
        if (!(await this.$refs.observer.validate())) {
          return
        }
        if (this.inspCatComputed == InspCat.OQC) {
          this.capaInspComputed = 0
        }
        if (this.inspCatComputed == InspCat.OQC_IQC && !this.capacityRequired) {
          this.capaInspComputed = 0
        }
        await this.$nextTick()
        this.startLoading()

        let body = {
          companyCd: this.companyCdComputed,
          compCd: this.compCd,
          location: this.location,
          companyName: this.companyNameComputed,
          companyCatCd: this.companyCatCdComputed,
          inspCat: this.inspCatComputed,
          supplierCds: this.supplierCdsComputed,
          isValid: this.isValidComputed,
          capaInsp: this.capaInspComputed,
          versionNo: this.versionNoComputed,
          calendarGroupCd: this.calendarGroupCd,
          shiftGroupCd: this.shiftGroupCd,
          isSrcInsp: this.needSourceComputed,
          shiftLists: [],
          gnsCompanies: {},
        }
        if (this.companyCatCdComputed == CompanyCatCd.SUPPLIER) {
          body.gnsCompanies = this.gnsCompanyComputed
        }
        if (this.inspCatComputed == InspCat.OQC_IQC) {
          body.shiftLists = this.shiftLists
        }
        const url = this.setting.url.replace('{id}', this.companyCdComputed)
        await API.post(url, body)

        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0002') }))
        this.close()
        this.$emit('change')
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0002') })))
      } finally {
        this.stopLoading()
      }
    },
    async getShiftLists() {
      this.startLoading()
      try {
        const params = {
          companyCd: this.companyCd,
          shiftGroupCd: this.propsShiftGroupCd,
          validOnly: true,
        }
        return await API.get('/master/companyCapas', params)
      } catch (error) {
        if (error.response.status == 404) {
          return this.getEmptyShiftLists()
        } else {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0130') })))
        }
      } finally {
        this.stopLoading()
      }
    },
    resetField() {
      this.compCdComputed = ''
      this.locationComputed = ''
      this.companyCdComputed = ''
      this.companyNameComputed = ''
      this.gnsCompanyComputed.companyName1 = ''
      this.gnsCompanyComputed.companyName2 = ''
      this.inspCatComputed = ''
      this.supplierCdsComputed = []
      this.capaInspComputed = ''
      this.isOpenedEditCapaDialog = false
      this.isEditedCapacity = false
      this.needSourceComputed = false
    },
    async getEmptyShiftLists() {
      try {
        this.startLoading()
        const params = {
          shiftGroupcd: this.shiftGroupCd,
          validOnly: true,
        }
        return await API.get('/master/shifts', params)
      } catch (error) {
        this.shiftLists = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    extend('companyCatValidation', {
      validate: async (value) => {
        let result = true
        if (this.companyCatCdComputed == CompanyCatCd.SUPPLIER) {
          try {
            this.startLoading()
            const gnsCompany = await API.get(`/gns/suppliers/${value}`)
            if (this.companyNameComputed === '') this.companyNameComputed = gnsCompany.omalName1
            this.gnsCompanyComputed.companyName1 = gnsCompany.omalName1
            this.gnsCompanyComputed.companyName2 = gnsCompany.omalName2
          } catch (error) {
            if (error.response.status == 404) {
              this.gnsCompanyComputed.companyName1 = ''
              this.gnsCompanyComputed.companyName2 = ''
              this.companyNameComputed = ''
              result = this.$t('MSG0099', { p0: value })
            } else {
              result = this.$t('MSG0002', { p0: this.$t('ELE0326') })
            }
          } finally {
            this.stopLoading()
          }
        }
        return result
      },
    })
    extend('companyLocationValidation', {
      validate: async () => {
        let result = true
        const value = this.companyCdComputed
        try {
          await API.get(`/master/companies/${value}`)
          result = this.$t('MSG0006')
        } catch (error) {
          if (error && error.response && error.response.status && error.response.status === 404) {
            return true
          } else {
            result = this.$t('MSG0002', { p0: this.$t('ELE0002') + ' ' + this.$t('ELE0380') })
          }
        }
        return result
      },
    })
    if (this.isEdit) {
      this.isEditedCapacity = true
    }
  },
}
</script>
